<template>
	<div id="app">
		<header-bar v-if="isRouterAlive" />
		<router-view v-if="isRouterAlive"></router-view>
		<footer-bar v-if="isRouterAlive" />
		<BackTop :duration="10">
			<div class="back-top">
				<Icon type="ios-arrow-up" />
			</div>
		</BackTop>
	</div>
</template>

<script>
	import $ from 'jquery'
	import headerBar from "./components/header-bar/index.vue"
	import footerBar from "./components/footer-bar/index.vue"
	export default {
		name: "app",  
		components: {
			headerBar,
			footerBar
		},
		provide() {
			return {
				reload: this.reload 
			}
		},
		data() {
			return {
				isRouterAlive: true,
			}
		},
		methods: {
			reload() {
				this.isRouterAlive = false
				this.$nextTick(function() {
					this.isRouterAlive = true
				})
			},
			
		},
		mounted() {
		},
	};

	$(document).ready(function() {
		"use strict";
		$(function() {
			/*-----------------   
			 Menu Stick 
		 -----------------*/
			var $window = $(window);
			$window.on('scroll', function() {
				var scroll = $window.scrollTop();
				if (scroll < 200) {
					$('.sticky-bar').removeClass('stick');
				} else {
					$('.sticky-bar').addClass('stick');
				}
			});
		});
	});
</script>

<style>
	html,
	body {
	  width: 100%;
	  height: 100%;
	  margin: 0;
	  padding: 0;
	}
	#app {
	  width: 100%;
	  height: 100%;
	}
	.back-top{
		background: #009c44;
		border-radius: 50%;
		color: #fff;
		width: 50px;
		height: 50px;
		display: flex;align-items: center;justify-content: center;
	}
	@import url("./assets/css/style.css");
	@import url("./assets/css/vendor/bootstrap.min.css");
	@import url("./assets/css/vendor/dlicon.css");
	@import url("./assets/css/vendor/font-awesome.min.css");
</style>
